import ProfileCard from 'src/Components/Profile/ProfileCard';
import { useIntl } from 'react-intl';
import SubscriptionCard from 'src/Components/Subscription/SubscriptionCard';
import DashboardCards from 'src/Components/DashboardComponents/DashboardCards';
import ShortcutRows from 'src/Components/Apps/ShortcutRows';
import Qualifications from 'src/Components/Qualifications/Qualifications';
import { useEffect } from 'react';
import { useReactiveVar } from '@apollo/client';
import { activePractitionerDetails } from 'src/graphql';
import MainLayout from 'src/Components/Pages/MainLayout';

const Dashboard = () => {
    const intl = useIntl();
    const practitionerData = useReactiveVar(activePractitionerDetails);

    useEffect(() => {
        document.title = intl.formatMessage({ id: 'LP_DASHBOARD_TITLE', defaultMessage: 'Practitioner Dashboard' });
    }, [intl]);

    return (
        <MainLayout>
            <div className='pb-20'>
                <div className='flex mb-6 justify-center xl:justify-start'>
                    {practitionerData
                        && <h1 className='text-headline-lg font-bold ' style={{ lineHeight: '45px' }}>
                            {
                                intl.formatMessage({
                                    id: 'LP_WELCOME',
                                    defaultMessage: 'Welcome',
                                })
                            } {practitionerData.firstName}
                        </h1>
                    }
                </div>
                {practitionerData
                    && <>
                        <section className='flex items-center flex-col xl:flex-row ml-2 md:ml-0
                            justify-center xl:justify-start xl:h-40'>
                            <ProfileCard
                                isLoading={false}
                                name={`${practitionerData?.firstName} ${practitionerData?.lastName}`}
                                email={practitionerData?.email}
                            />
                            <SubscriptionCard isLoading={false} profile={practitionerData} />
                        </section>
                        <DashboardCards isLoading={false} />
                        <ShortcutRows
                            isLoading={false}
                            productQualifications={practitionerData?.productQualifications}
                        />
                        <Qualifications />
                    </>}
            </div>
        </MainLayout>
    );
};

export default Dashboard;